import { lightTheme, darkTheme } from '../../styles/theme';

/**
 * Generate a random avatar color from the current theme's avatar color palette
 * @param isDarkMode - Whether to use dark theme colors
 * @returns A random avatar color hex string
 */
export function getRandomAvatarColor(isDarkMode: boolean = false): string {
  const colors = isDarkMode ? darkTheme.avatarColors : lightTheme.avatarColors;
  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
}

/**
 * Generate a deterministic avatar color based on a string input (like contact ID or name)
 * This ensures the same input always produces the same color
 * @param input - String to base the color on (e.g., contact ID)
 * @param isDarkMode - Whether to use dark theme colors
 * @returns A deterministic avatar color hex string
 */
export function getDeterministicAvatarColor(input: string, isDarkMode: boolean = false): string {
  const colors = isDarkMode ? darkTheme.avatarColors : lightTheme.avatarColors;
  
  // Simple hash function to convert string to number
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    const char = input.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

/**
 * Get the complete avatar colors array from the theme
 * @param isDarkMode - Whether to use dark theme colors
 * @returns Array of avatar colors from the theme
 */
export function getAvatarColors(isDarkMode: boolean = false): string[] {
  return isDarkMode ? darkTheme.avatarColors : lightTheme.avatarColors;
}

/**
 * Get the first avatar color from the theme (useful as a fallback)
 * @param isDarkMode - Whether to use dark theme colors
 * @returns The first avatar color from the theme
 */
export function getDefaultAvatarColor(isDarkMode: boolean = false): string {
  const colors = isDarkMode ? darkTheme.avatarColors : lightTheme.avatarColors;
  return colors[0];
} 